export const AstraFiEmployeeUserCardStatus = {
  Active: "active",
  Inactive: "inactive",
  Deleted: "deleted",
} as const;

export type AstraFiEmployeeUserCardStatus =
  (typeof AstraFiEmployeeUserCardStatus)[keyof typeof AstraFiEmployeeUserCardStatus];
